import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { ContentContainer } from '~/eds/src/components/ContentContainer/ContentContainer';

export const UnauthorizedDocumentViewer = memo(() => {
  const intl = useIntl();

  return (
    <ContentContainer
      placeholderContent={{
        icon: 'status-warning',
        title: intl.formatMessage({
          id: 'UnauthorizedDocumentViewer.title',
          defaultMessage: 'This document is not available',
          description: 'Title for unavailable document error',
        }),
        message: intl.formatMessage({
          id: 'UnauthorizedDocumentViewer.message',
          defaultMessage: 'It may be restricted or deleted.',
          description: 'Message explaining why document is not available',
        }),
      }}
    />
  );
});
